import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import OggettiUtili from "../../../../../utils/OggettiUtili";
import FocolaiServices from "../../../../../services/FocolaiServices";
import stylesWelcome from "../DatiSegnalazioneAnagrafici.module.css";
import Table from "../../../../../components/table/Table";
import Button from "../../../../../components/button/Button";

class TabellaFocolai extends Component {

    state = {
        rows: [],
        totalElementsTabFocolai: 0,
        page: 0,
        totalPages: 0,
        size: 10,
        disabilitaBottone: true,
        modificato: false,
        colsTabFocolai: [
            {
                key: "malattia", name: "DatiSegnalazioneAnagrafici.tabellaFocolai.malattia", tipo: "dizionario",
                oggetto: JSON.parse(sessionStorage.getItem("malattiePerCodice")), campo: "descrizione"
            },
            {key: "etichetta", name: "DatiSegnalazioneAnagrafici.tabellaFocolai.etichetta"},
            {
                key: "ulss",
                name: "DatiSegnalazioneAnagrafici.tabellaFocolai.ulss",
                tipo: "dizionario",
                oggetto: OggettiUtili.Ulss
            },
            {key: "dataCompilazione", name: "DatiSegnalazioneAnagrafici.tabellaFocolai.dataCompilazione", tipo: "data"},
            {key: "numeroCasi", name: "DatiSegnalazioneAnagrafici.tabellaFocolai.numCasi"},
            {
                key: "comunita",
                name: "DatiSegnalazioneAnagrafici.tabellaFocolai.comunita",
                tipo: "dizionario",
                oggetto: OggettiUtili.Collettivita,
                campo: "descrizione"
            },
            {
                key: "stato",
                name: "DatiSegnalazioneAnagrafici.tabellaFocolai.stato",
                tipo: "dizionario",
                oggetto: OggettiUtili.statoFocolaio,
                campo: "descrizione"
            }

        ],
        focolaioSelezionato: {}
    }

    constructor(props) {
        super(props);

        if (!this.props.idFocolaioSelezionato) {
            for (let i in this.state.colsTabFocolai) {
                this.state.colsTabFocolai[i]["sortDirection"] = "none"
            }
            this.state.colsTabFocolai.unshift({
                key: "checked",
                name: "",
                tipo: "checkbox",
                isRadio: true,
                deselect: false
            })
        }

        this.changePageTable = this.changePageTable.bind(this)
        this.changePaginationTable = this.changePaginationTable.bind(this)
        this.sendRequestFocolai = this.sendRequestFocolai.bind(this)
        this.selezionaFocolaio = this.selezionaFocolaio.bind(this)
        this.setFocolaioSelezionato = this.setFocolaioSelezionato.bind(this)
        this.getFocolaio = this.getFocolaio.bind(this)
        this.disableCheckbox = this.disableCheckbox.bind(this)
    }

    componentDidMount() {

        if (this.props.malattia && !this.props.idFocolaioSelezionato) {
            this.sendRequestFocolai(this.props.malattia)
        } else if (this.props.idFocolaioSelezionato) {
            this.getFocolaio()
        }

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.malattia !== this.props.malattia && !this.props.idFocolaioSelezionato) {
            this.sendRequestFocolai(this.props.malattia)
        }

    }

    disableCheckbox() {
        if (this.props.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
            this.props.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)
            return true
        else
            return false
    }

    selezionaFocolaio(row, isChecked) {
        if (row && isChecked)
            this.setState({focolaioSelezionato: row, disabilitaBottone: false})
        else {
            this.setState({focolaioSelezionato: null})
        }
        this.setState({modificato: true})
    }


    setFocolaioSelezionato() {
        let focolaioSelezionato = this.state.focolaioSelezionato
        this.props.setFocolaioSelezionato(focolaioSelezionato)
    }

    getFocolaio() {
        this.setState({loading: true});

        FocolaiServices.getFocolaio(this.props.idFocolaioSelezionato).then(data => {
            let res = [];
            res.push(data.data);

            this.setState({
                rows: res, totalElementsTabFocolai: 1,
                loading: false, totalPages: 1
            });
        });
    }

    sendRequestFocolai(malattia) {

        this.setState({loading: true});
        let params = {malattia: malattia, associabili: true}

        FocolaiServices.getFocolai(params)
            .then((data) => {
                let res = data.data.content;
                this.setState({
                    rows: res, totalElementsTabFocolai: data.data.totalElements,
                    loading: false, totalPages: data.data.totalPages
                });

            })
            .catch((reason) => {
                console.log("[Error] GetFocolai in errore ");
                //se l'errore è un 404:
                if (reason.response && reason.response.status == "404")

                    this.setState({rows: [], totalElements: 0, loading: false});
            });
    }


    changePageTable(sort, direction, page, size) {

        let params = {
            page: page,
            associabili: true
        }
        if (this.props.malattia) {
            params["malattia"] = this.props.malattia
        }
        if (sort !== null) {
            params.sort = sort
        }
        if (size != null) {
            if (size !== this.state.size) {
                params.size = this.state.size
            } else {
                params.size = size
            }
        }
        if (direction !== null) {
            params.order = direction
        }

        FocolaiServices.getFocolai(params)
            .then((data) => {
                let res = data.data.content;
                this.setState({
                    rows: res, totalElementsTabFocolai: data.data.totalElements,
                    totalPages: data.data.totalPages, page: page
                });
            })
            .catch(() => {
                console.log("[Error] GetFocolai in errore ");
                this.setState({rows: [], totalElementsTabFocolai: 0});
            });
    }

    changePaginationTable(sort, direction, page, size) {
        let params = {
            page: page,
            size: size,
            associabili: true
        }
        if (this.props.malattia) {
            params["malattia"] = this.props.malattia;
        }
        if (sort !== null) {
            params.sort = sort
        }

        if (direction !== null) {
            params.order = direction
        }

        this.setState({size: size})

        FocolaiServices.getFocolai(params)
            .then((data) => {
                let res = data.data.content;
                this.setState({
                    rows: res, totalElementsTabFocolai: data.data.totalElements,
                    totalPages: data.data.totalPages, page: page
                });
            })
            .catch(() => {
                console.log("[Error] GetFocolai in errore ");
                this.setState({rows: [], totalElementsTabFocolai: 0});
            });
    }


    render() {
        const {t} = this.props;

        const buttonCollega = (
            <div style={{
                display: "flex", justifyContent: "center", alignItems: "center", marginTop: "5rem"
            }}>
                <Button text="Collega" className={"btnWhite col-lg-2"}
                        style={{height: "2rem"}}
                        disabled={this.state.disabilitaBottone || this.props.segnalazione.migrazione || this.props.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                        this.props.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice}
                        onClick={this.setFocolaioSelezionato}>
                    {t("Buttons.Collega")}
                </Button>
            </div>
        )

        const tableFocolai = (
            <div>
                <h6>{t("DatiSegnalazioneAnagrafici.Collega_a_Focolaio_Esistente")}</h6>
                <hr className={stylesWelcome.hr}/>
                <div style={{marginTop: "2px"}}>
                    <Table cols={this.state.colsTabFocolai} rows={(this.props.segnalazione.migrazione || this.props.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                        this.props.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)
                        && (!this.props.segnalazione.focolai || this.props.segnalazione.focolai.length === 0)?[]:this.state.rows} title="Lista Focolai"
                           empty={this.state.rows && this.state.rows.length === 0}
                           emptyMsg={t("DatiSegnalazioneAnagrafici.tabellaFocolai.msgNoFocolai")}
                           lengthEditable={false}
                           bigTable={true}
                           totalPages={this.state.totalPages}
                           page={this.state.page}
                           changePage={this.changePageTable}
                           changePagination={this.changePaginationTable}
                           totalElements={this.state.totalElementsTabFocolai}
                           idFocolaioPadre={!this.state.modificato && this.props.idFocolaioPadre? this.props.idFocolaioPadre : null}
                           onSelectCheckbox={this.selezionaFocolaio}
                           nascondiPaginazione={this.props.idFocolaioSelezionato || this.props.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                           this.props.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice}
                           disableCheckbox={this.disableCheckbox}
                    />
                </div>
            </div>
        );


        return (
            <div style={{marginTop: "5rem"}}>
                {tableFocolai}
                {buttonCollega}
            </div>

        );
    }

}

export default withTranslation('common')(TabellaFocolai)
